import { render, staticRenderFns } from "./DetalheMercadoDestino.vue?vue&type=template&id=62749deb&scoped=true&"
import script from "./DetalheMercadoDestino.vue?vue&type=script&lang=js&"
export * from "./DetalheMercadoDestino.vue?vue&type=script&lang=js&"
import style0 from "./DetalheMercadoDestino.vue?vue&type=style&index=0&id=62749deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62749deb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VExpandTransition,VIcon,VOverlay,VPagination,VProgressCircular,VRow,VTextField})
